import { Controller } from "@hotwired/stimulus"

// Member Onboarding Controller
// Shows a welcome tour for new members on first login
export default class extends Controller {
  static targets = ["modal", "step", "progressBar", "progressText", "nextButton"]
  static values = {
    currentStep: { type: Number, default: 0 },
    totalSteps: { type: Number, default: 4 },
    progressTemplate: { type: String, default: "__current__ of __total__" },
    nextLabel: { type: String, default: "Next" },
    finishLabel: { type: String, default: "Finish" }
  }

  connect() {
    // Check if member has completed onboarding
    const completed = localStorage.getItem('memberOnboardingCompleted')
    if (!completed) {
      this.showOnboarding()
    }
  }

  showOnboarding() {
    if (this.hasModalTarget) {
      this.modalTarget.classList.remove('hidden')
      this.showStep(0)
    }
  }

  next() {
    if (this.currentStepValue < this.totalStepsValue - 1) {
      this.currentStepValue++
      this.showStep(this.currentStepValue)
    } else {
      this.complete()
    }
  }

  previous() {
    if (this.currentStepValue > 0) {
      this.currentStepValue--
      this.showStep(this.currentStepValue)
    }
  }

  skip() {
    this.complete()
  }

  complete() {
    localStorage.setItem('memberOnboardingCompleted', 'true')
    if (this.hasModalTarget) {
      this.modalTarget.classList.add('hidden')
    }
  }

  showStep(index) {
    // Hide all steps
    this.stepTargets.forEach(step => {
      step.classList.add('hidden')
    })

    // Show current step
    if (this.stepTargets[index]) {
      this.stepTargets[index].classList.remove('hidden')
    }

    // Update progress
    const progress = ((index + 1) / this.totalStepsValue) * 100
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${progress}%`
    }
    if (this.hasProgressTextTarget) {
      this.progressTextTarget.textContent = this.progressTemplateValue
        .replace("__current__", index + 1)
        .replace("__total__", this.totalStepsValue)
    }
    if (this.hasNextButtonTarget) {
      const label = index === this.totalStepsValue - 1 ? this.finishLabelValue : `${this.nextLabelValue} ->`
      this.nextButtonTarget.textContent = label
    }
  }
}
